import React, { useState, useEffect, useRef, useCallback } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";
import classnames from "classnames";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Row,
  Col,
  Button,
  Divider,
  message,
  Space,
} from "antd";

import {
  formItemLayout,
  tailFormItemLayout,
  smallFormItemLayout,
  smallTailFormItemLayout,
} from "./../../utils/Layouts";
import {
  EditOutlined,
  CloseOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onChange,
} from "../../utils/form_utilities";
import ReportHeading from "../../utils/ReportHeading";
import moment from "moment";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import axios from "axios";
import numberFormat from "../../utils/numberFormat";
import {
  addKeysToArray,
  onAccountSearch,
  onCustomerSearch,
} from "../../utils/utilities";
import round from "../../utils/round";
import { chunk, sumBy } from "lodash";
import ReactToPrint from "react-to-print";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import numberFormatInt from "../../utils/numberFormatInt";
import logo from "./../../images/logo-removebg-preview.png";
import CheckboxFieldGroup from "../../commons/CheckboxFieldGroup";

const { Content } = Layout;

const url = "/api/delivery-receipts/";
const title = "Statement of Account";

const initialValues = {
  period_covered: null,
  customer: null,
  items_per_page: 12,
};
export default function StatementOfAccountForm() {
  const [errors, setErrors] = useState({});
  const [company, setCompany] = useState({});
  const [records, setRecords] = useState([]);
  const auth = useSelector((state) => state.auth);
  const [state, setState] = useState(initialValues);
  const [options, setOptions] = useState({
    customers: [],
  });

  const report = useRef(null);

  const getReport = useCallback(({ ...form_data }) => {
    if (state.period_covered) {
      const loading = message.loading("Loading...");
      axios
        .post(`${url}statement-of-account`, form_data)
        .then((response) => {
          loading();
          if (response.data) {
            if (form_data?.is_excel) {
              return window.open(`/public/reports/${response.data.filename}`);
            }
            setRecords(response.data);
            setState((prevState) => ({
              ...prevState,
              total: response.data.total,
            }));
          }
        })
        .catch((err) => {
          loading();
          message.error("There was an error processing your request");
        });
    }
  });

  // useEffect(() => {
  //   const form_data = {
  //     period_covered: state.period_covered,
  //     account: state.account,
  //     branch: state.branch,
  //   };

  //   if (state.branch?.company?._id) {
  //     axios(`/api/companies/${state.branch?.company?._id}`)
  //       .then((response) => {
  //         setCompany({ ...response.data });
  //       })
  //       .catch((err) => console.log(err));
  //   }

  //   return () => {};
  // }, [state.period_covered, state.account, state.branch]);

  return (
    <Content className="content-padding">
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Reports</Breadcrumb.Item>
            <Breadcrumb.Item>{title}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <div style={{ background: "#fff", padding: 24, minHeight: 280 }}>
        <span className="module-title">{title}</span>
        <Divider />
        <Row>
          <Col span={12}>
            <RangeDatePickerFieldGroup
              label="Period Covered"
              name="period_covered"
              value={state.period_covered}
              onChange={(dates) =>
                setState((prevState) => ({
                  ...prevState,
                  period_covered: dates,
                }))
              }
              error={errors.period_covered}
              formItemLayout={smallFormItemLayout}
            />
          </Col>
          <Col span={12}>
            <SelectFieldGroup
              label="Account"
              value={state.account?.name}
              onSearch={(value) =>
                onAccountSearch({ value, options, setOptions })
              }
              onChange={(index) => {
                const account = options.accounts[index];
                setState((prevState) => ({
                  ...prevState,
                  account,
                }));
              }}
              error={errors.account}
              formItemLayout={smallFormItemLayout}
              data={options.accounts}
              column="name"
            />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <CheckboxFieldGroup
              label="With Items"
              name="with_items"
              error={errors.with_items}
              formItemLayout={smallFormItemLayout}
              checked={state.with_items}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
            />
          </Col>
          <Col span={12}>
            <CheckboxFieldGroup
              label="With Bigger Fonts"
              name="with_bigger_fonts"
              error={errors.with_bigger_fonts}
              formItemLayout={smallFormItemLayout}
              checked={state.with_bigger_fonts}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.checked,
                  setState,
                });
              }}
            />
          </Col>
          <Col span={12}>
            <TextFieldGroup
              label="# of Items/Page"
              name="items_per_page"
              error={errors.items_per_page}
              defaultValue={state.items_per_page}
              formItemLayout={smallFormItemLayout}
              onBlur={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value?.toUpperCase(),
                  setState,
                });
              }}
              autoComplete="off"
              help="Click outside to reflect changes"
            />
          </Col>
        </Row>
        <Form.Item {...tailFormItemLayout}>
          <Space>
            <Button
              className="control"
              onClick={() => {
                getReport({ ...state });
              }}
            >
              Search
            </Button>
            <Button
              className="control"
              onClick={() => {
                getReport({ ...state, is_excel: true });
              }}
            >
              Download to Excel
            </Button>
            <ReactToPrint
              trigger={() => (
                <Button type="primary" icon={<PrinterOutlined />}>
                  Print
                </Button>
              )}
              bodyClass="print"
              content={() => report.current}
            />
          </Space>
        </Form.Item>
        <div
          ref={report}
          className={classnames("soa", {
            "soa-2": state.with_bigger_fonts ? true : false,
          })}
        >
          {records.map((record) => {
            const chunked_items = chunk(
              record.items,
              state.items_per_page || 12
            );

            return chunked_items.map((items, chunked_index) => {
              return (
                <div className="page-break-after">
                  <Row className="m-t-3">
                    <Col span={18}>
                      <div>
                        <div className="checkout-image">
                          <img
                            src={logo}
                            style={{ height: "70px", verticalAlign: "top" }}
                          />
                          <div
                            className="has-text-weight-bold"
                            style={{
                              display: "inline-block",
                              marginTop: "18px",
                            }}
                          >
                            {state?.branch?.address} <br />
                            {state?.branch?.contact_no}
                          </div>{" "}
                        </div>
                      </div>
                    </Col>
                    <Col span={6}>
                      <div className="has-text-right has-text-weight-bold">
                        STATEMENT OF ACCOUNTS
                      </div>
                      <div className="has-text-right">
                        From:{" "}
                        {moment(state.period_covered?.[0])?.format(
                          "MM/DD/YYYY"
                        )}{" "}
                        To:{" "}
                        {moment(state.period_covered?.[1])?.format(
                          "MM/DD/YYYY"
                        )}
                      </div>
                    </Col>
                  </Row>

                  {/* <div className="has-text-right">
                  {moment(state.date).format("MM/DD/YYYY")}
                </div> */}
                  <div>
                    <Row>
                      <Col span={3}>Account of:</Col>
                      <Col
                        span={10}
                        className="has-text-weight-bold soa-highlight"
                      >
                        {record.account?.name}
                      </Col>
                      <Col span={7} className="has-text-right">
                        Contact No:
                      </Col>
                      <Col span={4} className="has-text-right">
                        {record.account?.contact_no}
                      </Col>
                    </Row>
                    <Row>
                      <Col span={3}>Address:</Col>
                      <Col span={10}>{record.account?.address}</Col>
                    </Row>
                    <Row></Row>
                    <Row>
                      <Col span={13}>&nbsp;</Col>
                    </Row>
                    <Row>
                      <Col span={3}>Page :</Col>
                      <Col span={10}>
                        {chunked_index + 1} of {chunked_items.length}
                      </Col>
                    </Row>
                  </div>

                  <div>
                    <table className="full-width">
                      <thead>
                        <tr>
                          <th className="has-text-centered">Date</th>

                          <th className="has-text-centered">Reference</th>
                          <th className="has-text-centered">
                            PO/DR Notes/Payment Details
                          </th>

                          {state.with_items && [
                            <th key="quantity" className="has-text-centered">
                              Qty
                            </th>,
                            <th key="stock" className="has-text-centered">
                              Product
                            </th>,
                            <th key="price" className="has-text-centered">
                              U/P
                            </th>,
                            <th key="amount" className="has-text-centered">
                              Amount
                            </th>,
                          ]}

                          <th className="has-text-centered" width={120}>
                            Total Amount{" "}
                          </th>
                          <th className="has-text-centered">Balance </th>

                          {/* <th className="has-text-centered">Payment Amount</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {chunked_index === 0 && (
                          <tr>
                            <td></td>
                            <td>Previous Balance</td>
                            <td></td>

                            {state.with_items && <td colSpan={4} />}
                            <td></td>
                            <td className="has-text-centered  has-text-weight-bold">
                              {numberFormat(record.previous_balance)}
                            </td>
                          </tr>
                        )}

                        {items.map((dr) => {
                          {
                            {
                              /* collections */
                            }
                            if (dr.items.length <= 0) {
                              return (
                                <tr>
                                  <td className="red">
                                    {moment(dr.date).format("MM/DD/YY")}
                                  </td>

                                  <td className="red">
                                    COL#{dr.collection_no}
                                  </td>
                                  <td className="red">
                                    {dr.payment_reference} {dr.bank_details}
                                  </td>
                                  {state.with_items && [
                                    <td key="1"></td>,
                                    <td key="2"></td>,
                                    <td key="3"></td>,
                                    <td key="4"></td>,
                                  ]}

                                  <td
                                    className="has-text-centered  has-text-weight-bold red"
                                    style={{ verticalAlign: "middle" }}
                                  >
                                    <span>{numberFormat(dr.total_amount)}</span>
                                  </td>
                                  <td className="has-text-centered  has-text-weight-bold">
                                    {numberFormat(dr._balance)}
                                  </td>
                                </tr>
                              );
                            }

                            return dr.items
                              .filter((o, index) => {
                                if (state.with_items) {
                                  return true;
                                }

                                return index === 0;
                              })
                              .map((item, i) => {
                                if (i === 0) {
                                  return (
                                    <tr>
                                      <td>
                                        {moment(dr.date).format("MM/DD/YY")}
                                      </td>

                                      <td>DR#{dr.dr_no}</td>
                                      <td>{dr.po_notes}</td>

                                      {state.with_items && [
                                        <td
                                          key="quantity"
                                          className="has-text-centered"
                                        >
                                          {numberFormatInt(item.quantity)}
                                        </td>,
                                        <td key="stock">{item.stock?.name}</td>,
                                        <td
                                          key="price"
                                          className="has-text-centered"
                                        >
                                          {numberFormat(item.price)}
                                        </td>,
                                        <td
                                          key="amount"
                                          className="has-text-centered"
                                        >
                                          {numberFormat(item.amount)}
                                        </td>,
                                      ]}

                                      <td
                                        className="has-text-centered  "
                                        style={{ verticalAlign: "middle" }}
                                        rowSpan={
                                          state.with_items ? dr.items.length : 1
                                        }
                                      >
                                        <span>
                                          {numberFormat(dr.total_amount)}
                                        </span>
                                      </td>
                                      <td
                                        className="has-text-centered"
                                        style={{ verticalAlign: "middle" }}
                                        rowSpan={
                                          state.with_items ? dr.items.length : 1
                                        }
                                      >
                                        {numberFormat(dr._balance)}
                                      </td>
                                      {/* <td
                                    className="has-text-centered"
                                    style={{ verticalAlign: "top" }}
                                    rowSpan={dr.items.length}
                                  >
                                    <table className="collection-table">
                                      {dr.collections.map((col) => {
                                        return (
                                          <tr>
                                            <td>
                                              {moment(col.date).format(
                                                "MM/DD/YYYY"
                                              )}
                                            </td>
                                            <td>{col.reference}</td>
                                            <td>
                                              {numberFormat(col.payment_amount)}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </table>
                                    
                                  </td> */}
                                      {/* <td className="has-text-centered">
                                    {moment(dr.due_date).format("MM/DD/YY")}
                                  </td> */}
                                    </tr>
                                  );
                                } else {
                                  return (
                                    <tr>
                                      <td></td>
                                      <td></td>
                                      <td></td>

                                      {state.with_items && [
                                        <td
                                          key="quantity"
                                          className="has-text-centered"
                                        >
                                          {numberFormatInt(item.quantity)}
                                        </td>,
                                        <td key="stock">{item.stock?.name}</td>,
                                        <td
                                          key="price"
                                          className="has-text-centered"
                                        >
                                          {numberFormat(item.price)}
                                        </td>,
                                        <td
                                          key="amount"
                                          className="has-text-centered"
                                        >
                                          {numberFormat(item.amount)}
                                        </td>,
                                      ]}
                                    </tr>
                                  );
                                }
                              });
                          }
                        })}
                      </tbody>
                    </table>
                  </div>
                  {chunked_index === chunked_items.length - 1 && [
                    <Row>
                      <Col span={12}>
                        <Row>
                          <Col span={8}>Prepared By:</Col>
                          <Col span={14} className="b-b-1">
                            {auth?.user?.name || ""}
                          </Col>
                        </Row>
                        <Row>
                          <Col span={8}>&nbsp;</Col>
                          <Col span={14}>&nbsp;</Col>
                        </Row>
                        <Row>
                          <Col span={8}>Approved By:</Col>
                          <Col span={14} className="b-b-1">
                            &nbsp;
                          </Col>
                        </Row>
                        <Row>
                          <Col span={8}>&nbsp;</Col>
                          <Col span={14}>&nbsp;</Col>
                        </Row>
                        <Row>
                          <Col span={8}>Received By:</Col>
                          <Col span={10} className="b-b-1">
                            &nbsp;
                          </Col>
                          <Col span={2}>Date:</Col>
                          <Col span={4} className="b-b-1">
                            &nbsp;
                          </Col>
                          <Col
                            offset={8}
                            span={10}
                            className="is-italic has-text-centered"
                            style={{ fontSize: "10px" }}
                          >
                            Signature over printed name
                          </Col>
                          <Col span={24} className="is-italic">
                            Received original invoices for payment
                          </Col>
                        </Row>
                      </Col>
                      <Col span={12}>
                        <div className="has-text-centered has-text-weight-bold b-1">
                          SUMMARY OF ACCOUNTS
                        </div>
                        <Row>
                          <Col span={12} className="has-text-right">
                            Previous Forwarded Balance:
                          </Col>
                          <Col
                            span={12}
                            className=" 
                      has-text-right has-text-weight-bold"
                          >
                            <span className="" style={{}}>
                              {numberFormat(record.previous_balance)}
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12} className="has-text-right">
                            Current Orders:
                          </Col>
                          <Col
                            span={12}
                            className=" 
                      has-text-right has-text-weight-bold"
                          >
                            <span
                              className=""
                              // style={{
                              //   borderBottom: "3px double #000",
                              //   fontSize: "18px",
                              // }}
                            >
                              {numberFormat(record.current_orders)}
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12} className="has-text-right b-t-1">
                            Gross Due:
                          </Col>
                          <Col
                            span={12}
                            className=" b-t-1 
                      has-text-right has-text-weight-bold"
                          >
                            <span
                              className=""
                              // style={{
                              //   borderBottom: "3px double #000",
                              //   fontSize: "18px",
                              // }}
                            >
                              {numberFormat(
                                record.current_orders + record.previous_balance
                              )}
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12} className="has-text-right">
                            Less Payments:
                          </Col>
                          <Col
                            span={12}
                            className=" 
                      has-text-right has-text-weight-bold"
                          >
                            <span
                              className="red"
                              // style={{
                              //   borderBottom: "3px double #000",
                              //   fontSize: "18px",
                              // }}
                            >
                              {numberFormat(0 - record.total_collection_amount)}
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col span={12} className="has-text-right b-t-1">
                            Current Due:
                          </Col>
                          <Col
                            span={12}
                            className=" 
                      has-text-right has-text-weight-bold b-t-1"
                          >
                            <span
                              className=" "
                              style={{
                                borderBottom: "3px double #000",
                                fontSize: "18px",
                              }}
                            >
                              {numberFormat(record.current_due)}
                            </span>
                          </Col>
                        </Row>
                      </Col>
                    </Row>,
                    <br />,
                    record.credit_memos.length > 0 ? (
                      <Row>
                        <span>CREDIT MEMOS</span>
                        <table className="full-width">
                          <thead>
                            <th className="has-text-centered">Date</th>
                            <th className="has-text-centered">Reference</th>
                            <th className="has-text-centered">Remarks</th>
                            <th className="has-text-centered">Total Amount</th>
                            <th className="has-text-centered">Unclaimed</th>
                            <th className="has-text-centered">Claimed</th>
                          </thead>
                          <tbody>
                            {record.credit_memos.map((o) => (
                              <tr>
                                <td>{moment(o.date).format("MM/DD/YYYY")}</td>
                                <td>{o.reference}</td>
                                <td>{o.remarks}</td>
                                <td className="has-text-centered">
                                  {numberFormat(o.total_amount)}
                                </td>
                                <td className="has-text-centered">
                                  {numberFormat(
                                    o.total_amount -
                                      parseFloat(o.total_credit_amount || 0)
                                  )}
                                </td>
                                <td className="has-text-centered">
                                  {numberFormat(o.total_credit_amount || 0)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th className="has-text-centered">
                              {numberFormat(
                                sumBy(
                                  record.credit_memos,
                                  (o) => o.total_amount
                                )
                              )}
                            </th>
                            <th className="has-text-centered">
                              {numberFormat(
                                sumBy(record.credit_memos, (o) => {
                                  const value =
                                    o.total_amount -
                                    parseFloat(o.total_credit_amount || 0);

                                  return value;
                                })
                              )}
                            </th>
                            <th className="has-text-centered">
                              {numberFormat(
                                sumBy(
                                  record.credit_memos,
                                  (o) => o.total_credit_amount
                                )
                              )}
                            </th>
                          </tfoot>
                        </table>
                      </Row>
                    ) : (
                      <span>NO CREDIT MEMOS</span>
                    ),
                  ]}
                </div>
              );
            });
          })}
        </div>
      </div>
    </Content>
  );
}
